<div class="bg-white p-6 rounded-lg border border-slate-200 shadow-sm">
  <h3 class="text-lg font-bold text-slate-800 mb-4">Quick Transfer</h3>
  
  <div class="flex items-center justify-between mb-4">
    @for(contact of contacts(); track contact.avatarId) {
      <div class="relative group">
        <button 
          (click)="selectContact(contact)"
          class="focus:outline-none"
          [attr.aria-label]="'Select ' + contact.name">
          <img 
            class="w-12 h-12 rounded-full ring-2 ring-offset-2 transition-all" 
            [class]="selectedContact() === contact ? 'ring-blue-500' : 'ring-transparent'"
            [src]="'https://picsum.photos/id/'+contact.avatarId+'/48/48'" 
            [alt]="contact.name">
        </button>
        <div class="absolute -top-8 left-1/2 -translate-x-1/2 px-2 py-1 bg-slate-800 text-white text-xs rounded-md opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
          {{contact.name}}
        </div>
      </div>
    }
     <button class="w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center text-slate-500 hover:bg-slate-200 transition-colors">
        <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" /></svg>
    </button>
  </div>

  <div class="mb-4">
    <label for="amount" class="block text-sm font-medium text-slate-600 mb-1">Amount</label>
    <div class="relative">
      <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <span class="text-slate-500">$</span>
      </div>
      <input type="text" id="amount" value="500.00" class="w-full bg-slate-50 border border-slate-200 rounded-lg py-2.5 pl-7 pr-12 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent font-semibold text-lg">
       <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
        <span class="text-slate-500 text-sm">USD</span>
      </div>
    </div>
  </div>

  <button class="w-full bg-blue-600 text-white font-semibold py-3 px-4 rounded-lg flex items-center justify-center space-x-2 hover:bg-blue-700 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
    <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5" /></svg>
    <span>Send Money</span>
  </button>

</div>
